import { GenericLink } from "../../link";
import { unstable_Typography } from "../../typography";
function introspectRichTextData(data, target) {
  if (data == null || data.document == null)
    return [];
  function introspectNode(node) {
    switch (node.object) {
      case "document":
      case "block":
        return node.nodes?.flatMap(introspectNode) ?? [];
      case "inline":
      case "text":
        return introspectInlineOrTextNode(node);
      default:
        return [];
    }
  }
  function introspectInlineOrTextNode(node) {
    switch (node.object) {
      case "inline":
        return [
          ...introspectInlineNode(node),
          ...node.nodes?.flatMap(introspectInlineOrTextNode) ?? []
        ];
      case "text":
        return node.marks?.flatMap(introspectMark) ?? [];
      default:
        return [];
    }
  }
  function introspectInlineNode(inline) {
    switch (inline.type) {
      case "link": {
        return GenericLink().introspect(
          inline.data,
          target
        );
      }
      default:
        return [];
    }
  }
  function introspectMark(mark) {
    const typographyResult = unstable_Typography().introspect(
      mark.data?.value,
      target
    );
    return [...typographyResult];
  }
  return introspectNode(data.document);
}
export {
  introspectRichTextData
};
//# sourceMappingURL=introspection.js.map